export const appPaddingSm = 28;
export const appPaddingMd = 40;
export const appPaddingLg = 52;
export const contentWidth = 1024;
export const pageHeaderFullHeight = 136;
export const uhfScreenMaxLg = 1083;
export const sideRailPaddingLeft = appPaddingMd - 8;
export const sideRailWidth = 182 + sideRailPaddingLeft;
